import InfoIcon from "@/core/ui/iconsax/linear/custom-info.svg"
import { TextVariantWithModifiers } from "@assets/style/appMuiTheme"
import { css } from "@assets/style/util/cssUtils"
import { DiscoIconButton, DiscoText } from "@disco-ui"
import { IconButtonProps } from "@material-ui/core"
import Tooltip, { TooltipProps } from "@material-ui/core/Tooltip"
import classNames from "classnames"
import { CSSProperties } from "react"
import classes from "./DiscoTooltip.module.css"

type TooltipVariant = "primary" | "arrow"

export type DiscoTooltipProps = Omit<TooltipProps, "title" | "children"> & {
  title?: React.ReactNode
  content: React.ReactNode
  variant?: TooltipVariant
  buttonProps?: IconButtonProps
  children?: React.ReactElement
  iconButtonProps?: IconButtonProps
  textVariant?: TextVariantWithModifiers
  titleVariant?: TextVariantWithModifiers
  dataPrivate?: boolean
  disabled?: boolean
  backgroundColor?: string
  style?: CSSProperties
}

function DiscoTooltip({
  children,
  content = "",
  placement,
  title,
  titleVariant,
  variant = "arrow",
  textVariant = "body-xs-600",
  buttonProps,
  dataPrivate,
  disabled,
  classes: muiClasses,
  style: customStyle,
  backgroundColor,
  ...rest
}: DiscoTooltipProps) {
  if (disabled || !content) return children || null

  return (
    <Tooltip
      title={
        <>
          {typeof title === "string" ? (
            <DiscoText
              testid={"DiscoTooltip.text"}
              variant={titleVariant || "body-md-600"}
              marginBottom={1}
              className={classNames({ "fs-mask": dataPrivate })}
            >
              {title}
            </DiscoText>
          ) : (
            title
          )}
          {typeof content === "string" ? (
            <DiscoText
              testid={"DiscoTooltip.text"}
              variant={textVariant || "body-xs-600"}
              marginTop={1}
              marginBottom={1}
              className={classNames(classes.text, { "fs-mask": dataPrivate })}
            >
              {content}
            </DiscoText>
          ) : (
            content
          )}
        </>
      }
      classes={{
        ...muiClasses,
        tooltipArrow: classNames(classes.tooltipArrow, muiClasses?.tooltipArrow, {
          [classes.backgroundColor]: Boolean(backgroundColor),
        }),
        arrow: classNames(classes.arrow, muiClasses?.arrow),
      }}
      placement={placement || "top"}
      arrow={rest.arrow || variant === "arrow"}
      PopperProps={{
        style: css({
          ...customStyle,
          "--tooltip-background-color": backgroundColor,
        }),
      }}
      {...rest}
    >
      {children || (
        <DiscoIconButton
          {...buttonProps}
          classes={{
            root: classNames(classes.iconButton, buttonProps?.classes?.root),
          }}
        >
          <InfoIcon />
        </DiscoIconButton>
      )}
    </Tooltip>
  )
}

export default DiscoTooltip
